import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BuilderNumber from '../../builderNumberVersion.json';
import { format } from 'date-fns';

class Footer extends Component {
    render() {
        return (
            <footer className="footer-container">
                {/* <span>&copy; {format(new Date(), 'yyyy')} Edgeworks Solutions Pte Ltd - EQuipWeb | {this.props.settings?.webVersion} | <small>WEB {BuilderNumber.builderNumberVersion} | API {this.props.settings?.apiBuildNumber}</small></span> */}
                <span>&copy; {format(new Date(), 'yyyy')} <a href="https://www.edgeworks.com.sg/" target='_blank'>Edgeworks Solutions Pte Ltd</a> - EQuipWeb {BuilderNumber.webVersion} | API {this.props.settings?.webVersion}</span>
            </footer>
        );
    }

}

Footer.propTypes = {
    setting: PropTypes.object
};

const mapStateToProps = state => ({ settings: state.settings })
export default connect(
    mapStateToProps,
    null
)(Footer);
